import React from 'react'

export default function DottedLoading() {
  return (
    <span className="dottedLoading"></span>
  )
}
